import { ICellRendererParams } from 'ag-grid-community'
import { WbsItemStatus } from '../../../domain/entity/WbsItemEntity'
import { ProgramStatusChip } from '../ProgramStatusChip'
import { ProjectStatusChip } from '../ProjectStatusChip'
import { WbsItemStatusChip } from '../WbsItemStatusChip'

// ステータスを持つ行の最小形。プログラムの管理 / プロジェクト報告のどちらの行型でも
// type の文字列値（PROGRAM/GROUP/PROJECT/WORKGROUP/PROCESS）は共通のため共用できる。
type StatusRow = { type?: string; status?: string | null }

const renderChip = (type: string | undefined, status: string) => {
  switch (type) {
    case 'PROGRAM':
      return <ProgramStatusChip status={status} />
    // GROUP は配下プロジェクトのステータスを集約しただけなので Project と同じ扱い。
    case 'GROUP':
    case 'PROJECT':
      return <ProjectStatusChip status={status} />
    case 'WORKGROUP':
    case 'PROCESS':
      return <WbsItemStatusChip status={status as WbsItemStatus} />
    default:
      return null
  }
}

/**
 * プログラムの管理 / プロジェクト報告で共用するステータス列セルレンダラ。
 * 行タイプに応じてステータスチップ（Program / Project / WbsItem）を出し分ける。
 */
export const ProgramManagementStatusCellRenderer = (
  params: ICellRendererParams<StatusRow>
) => {
  const status = params.data?.status
  if (!status) return null
  const chip = renderChip(params.data?.type, status)
  if (!chip) return null
  return <div className="sevend-ag-cell">{chip}</div>
}
